<template>
  <h3>introuvable</h3>
</template>

<style scoped>
p {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
</style>
